

















import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

import ManualCalendar        from "@/components/manual/ManualCalendar.vue";
import ManualSchedule        from "@/components/manual/ManualSchedule.vue";
import ManualGroupAndTeam    from "@/components/manual/ManualGroupAndTeam.vue";
import ManualCard            from "@/components/manual/ManualCard.vue";
import ManualNotification    from "@/components/manual/ManualNotification.vue";
import ManualFile            from "@/components/manual/ManualFile.vue";
import ManualChatting        from "@/components/manual/ManualChatting.vue";
import ManualWork            from "@/components/manual/ManualWork.vue";
import ManualVideoConference from "@/components/manual/ManualVideoConference.vue";
import ManualEtc             from "@/components/manual/ManualEtc.vue";

@Component({
    components: {
        ManualCalendar, ManualSchedule    , ManualGroupAndTeam   , 
        ManualCard    , ManualNotification, ManualFile           ,
        ManualChatting, ManualWork        , ManualVideoConference,
        ManualEtc     ,
    }    
}) export default class ManualSection extends Mixins(VueHoduCommon) {

    mounted() : void {

    }

}

